import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Stack icon — layered diamonds.
 *
 * Dual-tone layered style:
 * - Three stacked diamond/layer shapes (top full opacity, middle 60%, bottom 30%)
 * - Cyan accent fill at 12% on the top layer
 * - Node dot: small filled circle (r=1.8, fill=#00d4ff) with white center (r=0.7) at the top diamond center
 */
export const StackIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Bottom layer (30% opacity outline) */}
    <path
      d="M4 14 L12 10 L20 14 L12 18 Z"
      fill="none"
      stroke="currentColor"
      strokeOpacity={0.3}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Middle layer (60% opacity outline) */}
    <path
      d="M4 11 L12 7 L20 11 L12 15 Z"
      fill="none"
      stroke="currentColor"
      strokeOpacity={0.6}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Top layer: cyan accent fill + full opacity outline */}
    <path
      d="M4 8 L12 4 L20 8 L12 12 Z"
      fill="#00d4ff"
      fillOpacity={0.12}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Node dot at the center of the top diamond (cx=12, cy=8) */}
    <circle cx="12" cy="8" r={1.8} fill="#00d4ff" />
    <circle cx="12" cy="8" r={0.7} fill="white" />
  </RushaSvgIcon>
);

StackIcon.displayName = "StackIcon";

export default StackIcon;
